import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesRolloverFull from './futures-rollover-full';

const FuturesRolloverFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <FuturesRolloverFull {...props} />
    </QueryClientProvider>
  );
};

export { FuturesRolloverFullWidget }
